import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NavParams, PopoverController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { MatchService } from '../../_core/services/match.service';
import { ToastService } from '../../_core/services/toast.service';
import { Match } from '../../_shared/models/match.model';

@Component({
  standalone: false,
    selector: 'app-tracking-modes',
    templateUrl: './tracking-modes.component.html',
    styleUrls: ['./tracking-modes.component.scss'],
})
export class TrackingModesComponent implements OnInit {
    match: Match;
    form: UntypedFormGroup;
    updating = false;

    constructor(
        private fb: UntypedFormBuilder,
        private navParams: NavParams,
        private matchService: MatchService,
        private popoverController: PopoverController,
        private toastService: ToastService) { }

    ngOnInit() {
        this.match = this.navParams.get('match');
        this.buildForm();
    }

    buildForm() {
        this.form = this.fb.group({
            rallyLength: [this.match.dist.tracking.rallyLength],
            serveLocation: [this.match.dist.tracking.serveLocation]
        });
    }

    update() {
        this.updating = true;
        this.matchService
            .changeTrackingMode(this.match._id, this.form.value)
            .pipe(finalize(() => this.updating = false))
            .subscribe(
                res => {
                    this.toastService.presentToast(res.message);
                    this.popoverController.dismiss(res.data);
                },
                err => {
                    //console.log(err)
                }
            );
    }

}
